import React from "react";
import { Camera, Zap } from "lucide-react";
import "../styles/LookBook.css";
import vitalityHerbs from "../assets/images/herb1.avif";
import herbalBlend from "../assets/images/herb2.jpeg";
import naturalRoots from "../assets/images/herb3.jpg";
import energyFormula from "../assets/images/herb4.jpg";
import performanceSupport from "../assets/images/herb5.jpg";
import dailyStrength from "../assets/images/herb6.jfif";
import plantPower from "../assets/images/herb7.jpg";
import qualityTested from "../assets/images/herb8.webp";


const GALLERY_IMAGES = [
  {
    url: vitalityHerbs,
    caption: "Plant-Powered Herbs for Men’s Vitality",
  },
  {
    url: herbalBlend,
    caption: "Carefully Crafted Herbal Vitality Blend",
  },
  {
    url: naturalRoots,
    caption: "Traditional Roots Supporting Natural Strength",
  },
  {
    url: energyFormula,
    caption: "Daily Energy & Stamina Support Formula",
  },
  {
    url: performanceSupport,
    caption: "Designed to Support Performance & Confidence",
  },
  {
    url: dailyStrength,
    caption: "Consistent Strength for Everyday Challenges",
  },
  {
    url: plantPower,
    caption: "Clean, Plant-Based Power — No Harsh Stimulants",
  },
  {
    url: qualityTested,
    caption: "Quality-Tested for Balance, Safety & Trust",
  },
];


const ImageCard = ({ url, caption }) => (
  <div className="image-card">
    <img
      src={url}
      alt={caption}
      onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x600/8B4513/FFFFFF?text=Visual+Delight"; }}
    />
    <div className="overlay">
      <p>{caption}</p>
    </div>
  </div>
);

const LookBook = () => {
  return (
    <div className="lookbook-container">
      {/* Hero Section */} 
           <header
  style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80")`, 
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "white",
    padding: "100px 20px",
    textAlign: "center",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* Overlay for better text contrast */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
     
      borderBottomLeftRadius: "40px",
      borderBottomRightRadius: "40px",
      zIndex: 1,
   
    }}
  ></div>

<div style={{ position: "relative", zIndex: 2 }}>
  <h1
    style={{
      fontSize: "56px",
      fontWeight: "800",
      marginBottom: "16px",
    }}
  >
    BioSurge Herbal Wellness Blend
  </h1>

  <p
    style={{
      color: "whitesmoke",
      fontSize: "20px",
      maxWidth: "800px",
      margin: "0 auto",
      lineHeight: "1.6",
    }}
  >
    BioSurge is a plant-based herbal formulation created to complement modern
    lifestyles. It helps support daily energy, reduce tiredness, and promote a
    balanced and active routine with its traditional honey-based blend.
  </p>
</div>

</header>

      {/* Gallery Section */}
      <section className="gallery">
        {GALLERY_IMAGES.map((img, index) => (
          <ImageCard key={index} url={img.url} caption={img.caption} />
        ))}
      </section>

 

    
    </div>
  );
};

export default LookBook;
